// Short two-tone "ding" via Web Audio (no asset needed). Browsers require a prior user gesture.
let ctx = null;
let unlocked = false;
function getCtx() {
  if (!ctx) { try { ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { return null; } }
  return ctx;
}
export function unlockAudio() {
  const c = getCtx(); if (!c) return;
  if (c.state === 'suspended') c.resume().catch(() => {});
  unlocked = true;
}
if (typeof window !== 'undefined') {
  ['pointerdown', 'keydown', 'touchstart'].forEach(ev => window.addEventListener(ev, unlockAudio, { once: true, passive: true }));
}
export function playNotifySound() {
  try {
    if (localStorage.getItem('lc_sound') === 'off') return;
  } catch (e) {}
  const c = getCtx(); if (!c || !unlocked) return;
  const t = c.currentTime;
  [[880, 0], [1174.66, 0.12]].forEach(([freq, delay]) => {
    const o = c.createOscillator(); const g = c.createGain();
    o.type = 'sine'; o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, t + delay);
    g.gain.exponentialRampToValueAtTime(0.25, t + delay + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + delay + 0.35);
    o.connect(g); g.connect(c.destination);
    o.start(t + delay); o.stop(t + delay + 0.4);
  });
}

// ── Ring tone (incoming call): repeating double-beep until stopRing() or timeout ──
let ringTimer = null;
function beep(freq, at, dur, vol = 0.3) {
  const c = getCtx(); if (!c) return;
  const o = c.createOscillator(); const g = c.createGain();
  o.type = 'triangle'; o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, at);
  g.gain.exponentialRampToValueAtTime(vol, at + 0.03);
  g.gain.setValueAtTime(vol, at + dur - 0.05);
  g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  o.connect(g); g.connect(c.destination); o.start(at); o.stop(at + dur + 0.05);
}
export function startRing(maxMs = 45000) {
  try { if (localStorage.getItem('lc_sound') === 'off') return; } catch (e) {}
  const c = getCtx(); if (!c || !unlocked || ringTimer) return;
  const started = Date.now();
  const cycle = () => {
    if (Date.now() - started > maxMs) { stopRing(); return; }
    const t = c.currentTime;
    beep(932, t, 0.35); beep(1245, t + 0.45, 0.35);
    beep(932, t + 1.0, 0.35); beep(1245, t + 1.45, 0.35);
  };
  cycle();
  ringTimer = setInterval(cycle, 3000);
}
export function stopRing() {
  if (ringTimer) { clearInterval(ringTimer); ringTimer = null; }
}
export function isRinging() { return !!ringTimer; }
export function soundState() { return { hasCtx: !!ctx, state: ctx && ctx.state, unlocked, ringing: !!ringTimer }; }
if (typeof window !== 'undefined') { window.__lcSound = { playNotifySound, startRing, stopRing, unlockAudio, soundState }; }
